{% block postfinancecheckout_order_action_void %}
<sw-modal variant="small"
		  :title="$tc(`postfinancecheckout-order.modal.title.void`)"
		  @modal-close="$emit('modal-close')">

	{% block postfinancecheckout_order_action_void_amount %}
        {# Review if this v-model:checked="isVoid" needs to change to checked #}
		<mt-checkbox
				:label="$tc('postfinancecheckout-order.voidAction.confirm.message')"
				v-model:checked="isVoid">
        </mt-checkbox>
	{% endblock %}

	{% block postfinancecheckout_order_action_void_confirm_button %}
	<template #modal-footer>
		<mt-button variant="primary"
				   @click="voidPayment">
			{{ $tc('postfinancecheckout-order.refundAction.confirmButton.text') }}
		</mt-button>
	</template>
	{% endblock %}

	<mt-loader v-if="isLoading"></mt-loader>
</sw-modal>
{% endblock %}
